import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=7de82149&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de82149",
  null
  
)

export default component.exports